import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path clipRule="evenodd" d="M3 8h13v11H3V8ZM16 5v14h5V5h-5Z" stroke={color} strokeWidth="2" />
    <path d="M3 12h13M16 9h5" stroke={color} strokeWidth="2" />
  </svg>
);
